import { ExplicitType } from 'd2/queries'
import { assetUri } from 'd2/utils/Routes'
import { d } from 'd2/utils'
import { isNil } from 'lodash-es'
import { useEffect, useState } from 'react'
import AudioPlayer from '.'
import DisconnectedAudioPlayer from './DisconnectedAudioPlayer'
import Example from 'd2/components/Example'
import Playlist from './Playlist'
import SolidButton from 'd2/components/ButtonV2/SolidButton'
import useAudioPlayer from 'd2/hooks/useAudioPlayer'

const playlistData = [
  {
    duration: 1,
    explicitType: ExplicitType.clean,
    name: 'test 1',
    originalUrl: assetUri('/resources/try_everything.mp3'),
    track: 1,
  },
  {
    duration: 1,
    explicitType: ExplicitType.explicit,
    name: 'test 2',
    originalUrl: assetUri('/resources/sample.mp3'),
    track: 2,
  },
]

export const Default = (
  <Example container='card'>
    <AudioPlayer
      name='Try Everything'
      src={assetUri('/resources/try_everything.mp3')}
    />
  </Example>
)

export const Truncated = (
  <Example container='card'>
    <AudioPlayer
      name='Really Long Title That Is Truncated When The Audio Player Cannot Display The Full Title'
      src={assetUri('/resources/try_everything.mp3')}
    />
  </Example>
)

const HiddenExample = () => {
  const [hidden, setHidden] = useState<boolean>(false)

  return (<>
    <SolidButton
      // @ts-expect-error open and close are not valid icons?
      icon={hidden ? 'open' : 'close'}
      onClick={() => setHidden((current) => !current)}
    >
      { `CLICK TO ${hidden ? 'SHOW' : 'HIDE'}` }
    </SolidButton>
    <AudioPlayer
      hidden={hidden}
      name='Try Everything'
      src={assetUri('/resources/try_everything.mp3')}
    />
  </>)
}

export const Hidden = (
  <Example container='card'>
    <HiddenExample />
  </Example>
)

const AudioPlayerWithPlaylist = () => {
  const {
    currentSong,
    currentTime,
    playing,
    previousSong,
    setCurrentSong,
    setCurrentTime,
    setPlaying,
    togglePlaying,
  } = useAudioPlayer()

  useEffect(() => {
    if (isNil(currentSong)) {
      const [firstSong] = playlistData
      const { name, originalUrl, track } = d(firstSong)
      setCurrentSong({
        name,
        src: originalUrl,
        track,
      })
    }
  }, [currentSong, setCurrentSong])

  return (
    <>
      <DisconnectedAudioPlayer
        autoPlayOnTrackChange={Boolean(previousSong)}
        currentTime={currentTime}
        name={currentSong?.name}
        playing={playing}
        setCurrentTime={setCurrentTime}
        setPlaying={setPlaying}
        src={currentSong?.src}
        togglePlaying={togglePlaying}
      />
      <Playlist
        currentSong={currentSong ?? undefined}
        playing={playing}
        playlistData={playlistData}
        setCurrentSong={setCurrentSong}
        setPlaying={setPlaying}
        togglePlaying={togglePlaying}
      />
    </>
  )
}

export const AudioPlayerWithPlaylistExample = (
  <Example container='card'>
    <AudioPlayerWithPlaylist />
  </Example>
)
